import React, { useState, useEffect } from "react";
import { Wrench, Timer } from "lucide-react";
import api from "../lib/api";

export default function MaintenanceGuard({ children }) {
    const [maintenance, setMaintenance] = useState(null);
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        // Don't block admin routes
        if (window.location.pathname.startsWith("/sprava")) {
            setChecked(true);
            return;
        }
        api.get("/maintenance/status").then(r => {
            if (r.data?.maintenance) {
                setMaintenance(r.data);
            }
            setChecked(true);
        }).catch(() => setChecked(true));
    }, []);

    if (!checked) return null;

    if (maintenance) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 p-6" data-testid="maintenance-page">
                <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-8 text-center">
                    <div className="w-16 h-16 bg-amber-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                        <Wrench size={28} className="text-amber-600" />
                    </div>
                    <h1 className="text-2xl font-bold text-gray-900 mb-2">Údržba webu</h1>
                    <p className="text-gray-600 mb-4">{maintenance.message}</p>
                    {maintenance.show_countdown && maintenance.countdown_end && (
                        <CountdownTimer target={maintenance.countdown_end} />
                    )}
                    <p className="text-xs text-gray-400 mt-6">Solar-Green.cz</p>
                </div>
            </div>
        );
    }

    return children;
}

function CountdownTimer({ target }) {
    const [remaining, setRemaining] = useState("");

    useEffect(() => {
        const update = () => {
            const end = new Date(target).getTime();
            const now = Date.now();
            const diff = end - now;
            if (diff <= 0) { setRemaining("Již brzy..."); return; }
            const h = Math.floor(diff / 3600000);
            const m = Math.floor((diff % 3600000) / 60000);
            const s = Math.floor((diff % 60000) / 1000);
            setRemaining(`${h}h ${m}m ${s}s`);
        };
        update();
        const id = setInterval(update, 1000);
        return () => clearInterval(id);
    }, [target]);

    return (
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
            <div className="flex items-center justify-center gap-2 mb-1">
                <Timer size={14} className="text-amber-600" />
                <span className="text-xs font-medium text-amber-700">Předpokládaný konec údržby</span>
            </div>
            <p className="text-2xl font-bold text-amber-800 font-mono">{remaining}</p>
        </div>
    );
}
